import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/Landing.css";

function Nav() {
  const navigate = useNavigate();
  const [solid, setSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setSolid(window.scrollY > 20);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  // Lock body scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const links = [
    ["/", "Home"],
    ["/about", "About"],
    ["/projects", "Projects"],
    ["/contact1", "Contact"],
  ];

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <>
      <nav className={`nav${solid ? " solid" : ""}`}>
        <div className="nav-inner">
          <div className="nav-logo" onClick={() => go("/")} style={{color: "#3FC1C9"}}>
            SERITONEX
            <div className="nav-logo-dot" />
          </div>

          {/* Desktop links */}
          <div className="nav-links">
            {links.map(([path, label]) => (
              <button
                key={path}
                className={`nav-link${window.location.pathname === path ? " active" : ""}`}
                onClick={() => go(path)}
              >
                {label}
              </button>
            ))}
            {/*<button className="nav-cta" onClick={() => go("/shop")}>
              Shop
            </button>*/}
          </div>

          {/* Hamburger — mobile only */}
          <button
            className={`nav-hamburger${menuOpen ? " nav-hamburger--open" : ""}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile drawer overlay */}
      {menuOpen && (
        <div className="mob-nav-overlay" onClick={() => setMenuOpen(false)}>
          <div className="mob-nav-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="mob-nav-header">
              <div
                className="nav-logo"
                style={{ cursor: "pointer" }}
                onClick={() => go("/")}
              >
                SERITONEX
                <div className="nav-logo-dot" />
              </div>
              <button
                className="mob-nav-close"
                onClick={() => setMenuOpen(false)}
              >
                ✕
              </button>
            </div>
            <div className="mob-nav-links">
              {links.map(([path, label]) => (
                <button
                  key={path}
                  className={`mob-nav-link${window.location.pathname === path ? " mob-nav-link--active" : ""}`}
                  onClick={() => go(path)}
                >
                  {label}
                </button>
              ))}
              <button className="nav-cta" onClick={() => go("/shop")}>
              Shop
            </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const projects = [
  {
    title: "Inventory Manager",
    description:
      "A cloud-based inventory tracking system for small businesses.",
    tech: "React, Node.js, MongoDB",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "TaskBoard Pro",
    description: "A Trello-style task management app for remote teams.",
    tech: "React, Firebase, Tailwind CSS",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "Seritonex AI Toolkit",
    description:
      "A suite of AI tools including OCR, chatbot integration, and language processing.",
    tech: "Python, FastAPI, React",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "Software Development Hub",
    description:
      "A centralized platform for agile collaboration and rapid prototyping.",
    tech: "React, Node.js, PostgreSQL",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "ICT Solutions",
    description:
      "Enterprise-grade ICT solutions designed for large-scale operations.",
    tech: "Java, Spring Boot, OracleDB",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "Web Development Platform",
    description: "A modern platform that accelerates web app development.",
    tech: "React, Next.js, GraphQL",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "Custom Software Solutions",
    description:
      "Tailor-made enterprise software with scalability at its core.",
    tech: "C#, .NET, Azure",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
  {
    title: "Mobile App Development",
    description:
      "Cross-platform mobile apps with seamless UX and high performance.",
    tech: "Flutter, Kotlin, Swift",
    dev: "Solo Project",
    time: "3 months",
    img: "/Logo.png",
  },
];

function Projects() {
  return (
    <div className="landing-root">
      <Nav />
      <div className="page">
        {/* ── HERO ─────────────────────────────────── */}
        <section className="about-hero">
          <div className="about-hero-inner container">
            <div className="overline">Our Work</div>
            <h1 className="about-title">
              Our <span>Projects</span>.<br />
              <em>Built</em> To Last.
            </h1>
            <p className="about-sub">
              From startups to enterprises — we deliver powerful, scalable, and
              reliable digital solutions that make a real impact.
            </p>
          </div>
        </section>

        <div className="h-rule" />

        {/* ── PROJECTS GRID ────────────────────────── */}
        <section className="services-section">
          <div className="services-header">
            <div>
              <div className="overline">Portfolio</div>
              <h2 className="services-title">
                What We've
                <br />
                <em>Delivered</em>
              </h2>
            </div>
            <p className="services-desc">
              A selection of <br />
              our best work
              <br /> across industries,
              <br /> platforms, <br />
              and technologies.
            </p>
          </div>

          {/* No inline style — CSS media queries handle column count */}
          <div className="services-rail">
            {projects.map((project, index) => (
              <div key={index} className="svc-card">
                <div className="svc-img-wrap">
                  <img
                    src={project.img}
                    alt={project.title}
                    className="svc-img"
                  />
                </div>
                <div className="svc-body">
                  <div className="svc-num">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <div className="svc-title">{project.title}</div>
                  <p className="svc-desc">{project.description}</p>
                  <p
                    className="svc-desc"
                    style={{ marginTop: "0.5rem", opacity: 0.6 }}
                  >
                    <span
                      style={{
                        color: "var(--volt)",
                        fontFamily: "var(--f-mono)",
                        fontSize: "0.65rem",
                        letterSpacing: "0.06em",
                      }}
                    >
                      STACK —
                    </span>{" "}
                    {project.tech}
                  </p>
                  <p
                    className="svc-desc"
                    style={{ marginTop: "0.3rem", opacity: 0.6 }}
                  >
                    <span
                      style={{
                        color: "var(--volt)",
                        fontFamily: "var(--f-mono)",
                        fontSize: "0.65rem",
                        letterSpacing: "0.06em",
                      }}
                    >
                      DEVS —
                    </span>{" "}
                    {project.dev}
                  </p>
                                    <p
                    className="svc-desc"
                    style={{ marginTop: "0.3rem", opacity: 0.8 }}
                  >
                    <span
                      style={{
                        color: "var(--volt-2)",
                        fontFamily: "var(--f-mono)",
                        fontSize: "0.62rem",
                        letterSpacing: "0.03em",
                      }}
                    >
                      Time to complete —
                    </span>{" "}
                    {project.time}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── CALL TO ACTION ───────────────────────── */}
        <div className="cta-banner">
          <h2 className="cta-banner-title">
            Have an idea? Let's build
            <br />
            something <span>amazing</span>.
          </h2>
          <a href="/contact1" className="cta-banner-btn">
            Start Your Project
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Projects;
